import {Raven} from 'vue-raven'
import _ from 'lodash'
import {workflowApi} from '../../../api/workflow'

export const WORKFLOW_GLOBAL_PROPERTIES_FETCH = 'WORKFLOW_GLOBAL_PROPERTIES_FETCH'
export const WORKFLOW_GLOBAL_PROPERTIES_SET = 'WORKFLOW_GLOBAL_PROPERTIES_SET'
export const WORKFLOW_GLOBAL_PROPERTIES_SET_IS_LOADING = 'WORKFLOW_GLOBAL_PROPERTIES_SET_IS_LOADING'

const state = {
    /**
     * global properties available in every workflow
     * and can be overridden on the individual workflow level
     * if a property is added with the same name
     */
    globalProperties: [],
    isGlobalPropertiesLoading: false
}

const getters = {
    globalProperties: state => state.globalProperties || [],
    globalPropertiesData: (state, getters) => getters.globalProperties
        .filter(p => p && p.config && p.config.name)
        .map(p => ({...p.config})),
    isGlobalPropertiesLoading: state => state.isGlobalPropertiesLoading
}

const mutations = {
    [WORKFLOW_GLOBAL_PROPERTIES_SET]: (state, props) => {
        state.globalProperties = _.isArray(props) ? props : []
    },
    [WORKFLOW_GLOBAL_PROPERTIES_SET_IS_LOADING]: (state, value) => {
        state.isGlobalPropertiesLoading = Boolean(value)
    }
}

const actions = {
    [WORKFLOW_GLOBAL_PROPERTIES_FETCH]: async({commit}) => {
        commit(WORKFLOW_GLOBAL_PROPERTIES_SET_IS_LOADING, true)
        const {data, error} = await workflowApi.fetchGlobalProperties()
        if (error) {
            Raven.captureException(error)
        } else {
            commit(WORKFLOW_GLOBAL_PROPERTIES_SET, data)
        }
        commit(WORKFLOW_GLOBAL_PROPERTIES_SET_IS_LOADING, false)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
